import { z } from "zod/v4-mini";

import { TandemCommand, TandemResponse } from "@/lib/drivers/tandem/TandemTypes";
import { Schema } from "@/utils/zodUtils";

export type LogSize = {
  entries: number;
  startSeq: number;
  endSeq: number;
};

export type LogSizePayload = {
  entries: number;
  start_seq: number;
  end_seq: number;
};

export const logSizePayloadSchema: Schema<LogSizePayload> = z.object({
  entries: z.number(),
  start_seq: z.number(),
  end_seq: z.number(),
});

export const LOG_SIZE_RESPONSE = {
  value: 169,
  name: "Event History Log Size Response",
  version: 36102,
  format: "iii",
  fields: ["entries", "start_seq", "end_seq"] as const,
  postprocess: rec => ({
    entries: rec.entries,
    startSeq: rec.start_seq,
    endSeq: rec.end_seq,
  }),
  schema: logSizePayloadSchema,
} as const satisfies TandemResponse<LogSizePayload, LogSize>;

export const LOG_SIZE_COMMAND = {
  value: 168,
  name: "Event History Log Size Request",
  version: 36102,
  response: LOG_SIZE_RESPONSE,
} as const satisfies TandemCommand<LogSizePayload, LogSize>;
